/* Jing Soda PDP — gallery thumbs, qty stepper, variant select + live price (price row + sticky bar; the add button carries no price). */
(function () {
  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  function init() {
    var form = document.getElementById('jing-pdp-form');
    var mainImg = document.getElementById('jing-main-img');

    // gallery thumbnails
    document.querySelectorAll('.jing-pdp__thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var full = btn.getAttribute('data-full');
        // srcset would win over src, so drop it once a thumbnail is chosen
        if (full && mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = full; }
        document.querySelectorAll('.jing-pdp__thumb').forEach(function (b) { b.classList.remove('is-on'); b.setAttribute('aria-pressed', 'false'); });
        btn.classList.add('is-on');
        btn.setAttribute('aria-pressed', 'true');
      });
    });

    if (!form) return;
    var qtyInput = form.querySelector('.jing-qty__input');
    var totalEl = document.getElementById('jing-pdp-total');

    function selectedPrice() {
      var checked = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
      return checked ? parseInt(checked.getAttribute('data-price'), 10) : null;
    }

    // subscription purchase options (native selling plans)
    var planWrap = form.querySelector('.jing-pdp__plans');
    var planHidden = document.getElementById('jing-selling-plan');
    var planFreq = planWrap && planWrap.querySelector('.jing-plan__freq');
    function planPct() {
      return planWrap ? parseInt(planWrap.getAttribute('data-save-pct'), 10) || 0 : 0;
    }
    function subPrice(price) {
      return Math.round(price * (100 - planPct()) / 100);
    }
    function subscribing() {
      var r = planWrap && planWrap.querySelector('input[name="jing_plan_choice"]:checked');
      return r && r.value !== '';
    }
    function syncPlan() {
      if (!planWrap || !planHidden) return;
      var checked = planWrap.querySelector('input[name="jing_plan_choice"]:checked');
      planWrap.querySelectorAll('.jing-plan').forEach(function (l) { l.classList.remove('is-on'); });
      if (checked) checked.closest('.jing-plan').classList.add('is-on');
      var id = checked ? checked.value : '';
      if (id && planFreq) id = planFreq.value;
      planHidden.value = id;
      planHidden.disabled = !id; // keep selling_plan out of the form data for one-time
      updatePriceRow();
      updateTotal();
    }
    function updatePriceRow() {
      var checked = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
      if (!checked) return;
      var p = parseInt(checked.getAttribute('data-price'), 10);
      var cmpAttr = checked.getAttribute('data-compare');
      var priceEl = document.getElementById('jing-pdp-price');
      var cmpEl = document.getElementById('jing-pdp-compare');
      if (priceEl && !isNaN(p)) priceEl.textContent = money(subscribing() ? subPrice(p) : p);
      if (cmpEl && cmpAttr !== null) {
        var cmp = parseInt(cmpAttr, 10) || 0;
        cmpEl.style.display = cmp > p ? '' : 'none';
        if (cmp > p) cmpEl.textContent = money(cmp);
      }
    }

    function updatePlanPrices() {
      updatePriceRow();
      if (!planWrap) return;
      var p = selectedPrice();
      if (p == null) return;
      var ot = planWrap.querySelector('[data-plan-price="onetime"]');
      var sb = planWrap.querySelector('[data-plan-price="sub"]');
      if (ot) ot.textContent = money(p);
      if (sb) sb.textContent = money(subPrice(p));
    }
    if (planWrap) {
      // Recharge's app embed injects its own subscription widget into the
      // form; the theme renders native purchase options — drop the injected
      // one so the option isn't shown twice.
      var stripRc = function () {
        form.querySelectorAll('.rc-container-wrapper, .rc_container_wrapper').forEach(function (n) { n.remove(); });
      };
      stripRc();
      new MutationObserver(stripRc).observe(form, { childList: true, subtree: true });

      planWrap.querySelectorAll('input[name="jing_plan_choice"]').forEach(function (r) {
        r.addEventListener('change', syncPlan);
      });
      if (planFreq) planFreq.addEventListener('change', function () {
        var sub = planWrap.querySelector('input[name="jing_plan_choice"][value]:not([value=""])');
        if (sub) sub.checked = true;
        syncPlan();
      });
    }

    var stickyPrice = document.getElementById('jing-sticky-price');
    function updateTotal() {
      var price = selectedPrice();
      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      if (price == null) return;
      if (subscribing()) price = subPrice(price);
      if (totalEl) totalEl.textContent = money(price * qty);
      if (stickyPrice) stickyPrice.textContent = money(price * qty);
    }

    // sticky add-to-cart bar: appears once the main buy button scrolls above the viewport
    var stickyBar = document.getElementById('jing-sticky-bar');
    var mainAdd = form.querySelector('.jing-pdp__add');
    if (stickyBar && mainAdd && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-on', show);
        stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
        // inert keeps its buttons out of the Tab order while it is off screen
        stickyBar.inert = !show;
      }, { threshold: 0 }).observe(mainAdd);
    }

    // qty steppers
    form.querySelectorAll('.jing-qty__btn').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = parseInt(b.getAttribute('data-step'), 10);
        var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step);
        qtyInput.value = v;
        updateTotal();
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', updateTotal);

    // variant cards
    form.querySelectorAll('input[name="id"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        form.querySelectorAll('.jing-pack').forEach(function (p) { p.classList.remove('is-on'); });
        var label = radio.closest('.jing-pack');
        if (label) label.classList.add('is-on');
        var img = radio.getAttribute('data-img');
        if (img && mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = img; }
        updatePlanPrices();
        updateTotal();
      });
    });

    updatePlanPrices();
    updateTotal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
